module.exports = __webpack_public_path__ + "img/falso-verdadero.2638e28b.svg";